<script lang="ts">
  import type { ToolCall, ToolCallStatus } from '../types/debugger';

  let { toolCall }: { toolCall: ToolCall } = $props();

  let expanded = $state(false);

  const borderColors: Record<ToolCallStatus, string> = {
    running: 'border-l-tool-running',
    complete: 'border-l-tool-complete',
    error: 'border-l-error',
  };

  const statusBadge: Record<ToolCallStatus, { class: string; label: string }> = {
    running: { class: 'bg-accent/20 text-accent', label: 'Running' },
    complete: { class: 'bg-success/20 text-success', label: 'Complete' },
    error: { class: 'bg-error/20 text-error', label: 'Error' },
  };

  function formatJson(obj: any): string {
    try { return JSON.stringify(obj, null, 2); }
    catch { return String(obj); }
  }
</script>

<div class="my-2 rounded-md bg-bg-card border border-border-light border-l-[3px] {borderColors[toolCall.status]} overflow-hidden transition-all duration-300
  {toolCall.status === 'running' ? 'animate-glow-border' : ''}">
  <!-- Header -->
  <button
    onclick={() => expanded = !expanded}
    class="w-full flex items-center gap-2 px-3 py-2 text-left hover:bg-bg-hover transition-colors"
  >
    <span class="text-xs">🔧</span>
    <span class="text-xs font-medium text-text-primary">{toolCall.name}</span>
    <span class="text-[10px] px-1.5 py-0.5 rounded-full font-medium {statusBadge[toolCall.status].class}">
      {statusBadge[toolCall.status].label}
    </span>
    {#if toolCall.duration}
      <span class="text-[10px] text-text-muted ml-auto">{toolCall.duration}ms</span>
    {/if}
    <svg
      class="w-3 h-3 text-text-muted transition-transform {expanded ? 'rotate-180' : ''}"
      fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"
    >
      <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
    </svg>
  </button>

  <!-- Body -->
  {#if expanded}
    <div class="border-t border-border-light px-3 py-2 space-y-2 animate-slide-down">
      {#if toolCall.input}
        <div>
          <span class="text-[10px] text-text-muted uppercase tracking-wider">Input</span>
          <pre class="mt-1 text-[10px] text-text-secondary font-mono bg-bg-dark/50 rounded p-2 overflow-x-auto max-h-32">{formatJson(toolCall.input)}</pre>
        </div>
      {/if}
      {#if toolCall.output}
        <div>
          <span class="text-[10px] text-text-muted uppercase tracking-wider">Output</span>
          <pre class="mt-1 text-[10px] text-text-secondary font-mono bg-bg-dark/50 rounded p-2 overflow-x-auto max-h-32">{toolCall.output}</pre>
        </div>
      {/if}
    </div>
  {/if}
</div>
